import { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { ChatHeartbeatMutation, ChatLeaveMutation } from "core/mutations";

const HEARTBEAT_INTERVAL = 30_000; // 30 seconds

export default function useChatHeartbeat(chatRoomId, viewer) {
  const [chatHeartbeat] = useMutation(ChatHeartbeatMutation);
  const [chatLeave] = useMutation(ChatLeaveMutation);

  useEffect(() => {
    if (!viewer || !chatRoomId) return;

    chatHeartbeat({ variables: { chatRoomId } });

    const interval = setInterval(() => {
      chatHeartbeat({ variables: { chatRoomId } });
    }, HEARTBEAT_INTERVAL);

    return () => {
      clearInterval(interval);
      chatLeave({ variables: { chatRoomId } });
    };
  }, [chatRoomId, viewer]);
}
